// extracted by mini-css-extract-plugin
export default {"container":"ENWS3r","desktop":"JF66Xi","logo":"ECzuCQ","horizontal":"WYzIvw","mobile":"H0G1C4"};